import React from 'react';
import HeaderSection from './HeaderSection';
import FeatureSection from './FeatureSection';

const Index = () => {
  return (
    <div className="flex flex-col my-24" data-aos="flip-up">
      <div className="flex flex-col items-center" style={{ height: 'auto' }}>
        <HeaderSection />
      </div>
      <div className="flex flex-row justify-between mt-8" style={{ height: 'auto' }}>
        <FeatureSection />
      </div>
    </div>
  );
};

export default Index;

